import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Label } from "@client.components/Modal";
import { useSelector } from "react-redux";
import { makeTeams } from "@client.pages/Settings/reducer";
import TagAutocomplete from "@client.components/TagAutocomplete";

const DropdownTeams = ({ error, onSelect, value }) => {
  const { t } = useTranslation();
  const teams = useSelector(makeTeams);
  const getPreparedValue = (arr) =>
    arr.map((team) => ({
      value: team.id,
      label: team.name,
    }));

  return (
    <>
      <Label
        term="components.UserManagementContent.teams"
        className="tag-label"
      />
      <TagAutocomplete
        allowNew
        newOptionText={t("components.UserManagementContent.addNewTeam")}
        items={getPreparedValue(teams)}
        value={getPreparedValue(value)}
        error={error}
        placeholderText={t("components.UserManagementContent.placeholder.team")}
        onSelect={(items) => {
          onSelect(items.map((t) => ({ id: t.value, name: t.label })));
        }}
      />
    </>
  );
};

DropdownTeams.defaultValue = {
  selectedRole: undefined,
};

DropdownTeams.propTypes = {
  error: PropTypes.array,
  value: PropTypes.array,
  selectedSalaryRangeId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};

export default DropdownTeams;
